export default "__VITE_ASSET__C28G0O6j__"